module.exports = __webpack_public_path__ + "img/Player2022.24204b29.png";